module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_18.1fb95a71.png";